define('helperContent-getLastQuiz',['helperContent-getEntity'] , function(getEntity) {
    'use strict';

    var entity = null,
        lastQuizEntity,

    getLastQuiz = function (trainingMap, contentEntities) {

       for (var i = 0; i < trainingMap.length; i++) {

           entity = getEntity(trainingMap[i], contentEntities);

           if (entity && entity.hasOwnProperty('typeId') && entity.typeId === 19) {
               lastQuizEntity = entity;
           }
       }

       return {
           entity: lastQuizEntity,
           ID: lastQuizEntity.contentEntityId
       };
    };

    return getLastQuiz;
});


